import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { AppService } from "../../core/services/app.service";
import { of, Subject } from "rxjs";
import { exhaustMap, map } from "rxjs/internal/operators";
import { tap } from "rxjs/operators";
import {ToastrService} from "ngx-toastr";

@Injectable({
    providedIn: 'root'
})

export class FriendService {
    constructor(public http: HttpClient,
                protected toastr: ToastrService) {
        this.fetchUser.pipe(exhaustMap(() => {
            return this.getFriendList(encodeURIComponent(JSON.stringify({
                following: true,
            })))
        })).subscribe((res: any) => {
            for (let user of res.Data) {
                this.myFollowingList.push(user.addresseeId);
                if (user.subscribeStatus) {
                    this.mySubscribeList.push(user.addresseeId);
                }
            }
            this.cacheFollowRequest = true;
            this.cacheSubject.next({
                myFollowingList : this.myFollowingList,
                mySubscribeList : this.mySubscribeList,
            });
            this.cacheSubject.complete();
        })
    }

    public static friendAPI = AppService.getApiUrl() + '/api/friends/';

    cacheFollowRequest = false;
    myFollowerList = [];
    myFollowingList = [];
    mySubscribeList = [];
    cacheSubject = new Subject();
    fetchUser = new Subject();

    getFriendList(criteria, extraOptions = {}) {
        let options = {
            headers: { //clear cache request
                'Expires': '0',
                'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
                'Pragma': 'no-cache',
            }
        }

        options = {
            ...options,
            ...extraOptions,
        }

        return this.http.get(FriendService.friendAPI + `getFriendList?criteria=${criteria}`, options);
    }

    followRequest(data) {
        const action = data.action;
        const userId = data.addresseeId;
        return this.http.post(FriendService.friendAPI + `followRequest`, data).pipe(tap((res)=> {
            if (action == 'follow') {
                this.myFollowingList.push(userId);
            }  else if (action === 'unfollow')  {
                this.myFollowingList = this.myFollowingList.filter(item => userId != item);
                this.mySubscribeList = this.mySubscribeList.filter(item => userId != item);
            } else if (action === 'subscribe')  {
                this.mySubscribeList.push(userId);
                this.toastr.success('You will now be notified when user uploads a photo');
            } else {
                this.mySubscribeList = this.mySubscribeList.filter(item => userId != item);
            }
        }));
    }

    checkHasFollow(userId, checkIsSubscribe= null) {
        if (!this.cacheFollowRequest) {
            this.fetchUser.next(true);
        } else {
            if (checkIsSubscribe !== null) {
                if (checkIsSubscribe) {
                    return of(this.mySubscribeList.includes(userId));
                } else {
                    return of(this.myFollowingList.includes(userId) && !this.mySubscribeList.includes(userId));
                }

            } else {
                return of(this.myFollowingList.includes(userId));
            }
        }

        return this.cacheSubject.pipe(map((data: any) => {
            if (checkIsSubscribe !== null) {
                if (checkIsSubscribe) {
                    return data.mySubscribeList.includes(userId);
                } else {
                    return data.myFollowingList.includes(userId) && !data.mySubscribeList.includes(userId);
                }
            } else {
                return data.myFollowingList.includes(userId);
            }
        }));
    }
}
